import { camelize } from "camelscore";
import { AlgoliaListingHit } from "storefront/Listing";
import { GrailedAPILightListing } from "storefront/Listing/GrailedAPILightListing";
import { AlgoliaListing } from "storefront/Listing/AlgoliaListing";

export type AlgoliaInstantSearchListing = AlgoliaListingHit & {
  _tag: "AlgoliaInstantSearch";
};

export const isAlgoliaInstantSearchListing = (
  listing:
    | AlgoliaInstantSearchListing
    | GrailedAPILightListing
    | AlgoliaListing,
): listing is AlgoliaInstantSearchListing =>
  // eslint-disable-next-line no-underscore-dangle
  "_tag" in listing && listing._tag === "AlgoliaInstantSearch";

// NOTE: We can continue to improve this type with the actual data that come back from Algolia.
export const hitToAlgoliaInstantSearchListing = (
  hit: AlgoliaListingHit,
): AlgoliaInstantSearchListing => ({
  /* eslint-disable no-underscore-dangle */
  ...camelize(hit),
  _tag: "AlgoliaInstantSearch",
  objectID: hit.objectID,
  __queryID: hit.__queryID,
  __position: hit.__position,
  /* eslint-enable no-underscore-dangle */
});
